import React from "react";
import { motion } from 'motion/react';
export function LinearProgressGraphic({ color = 'rgba(0, 113, 206, 1)', colorLight = 'rgba(102, 178, 255, 1)' }) {
    const colorGlow = color.replace('1)', '0.2)');
    return (React.createElement("div", { style: { padding: '0px', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
        React.createElement("svg", { width: "100%", height: "100%", viewBox: "10 40 220 220", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "overflow-visible", preserveAspectRatio: "xMidYMid meet", style: { display: 'block', maxWidth: '100%', maxHeight: '100%' } },
            React.createElement(motion.path, { d: "M 30 210 L 90 210 L 90 150 L 150 150 L 150 90 L 210 90", stroke: colorGlow, strokeWidth: "3", fill: "none", initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: {
                    duration: 2,
                    repeat: Infinity,
                    repeatType: "loop",
                    ease: "easeInOut",
                    repeatDelay: 0.5
                } }),
            React.createElement(motion.path, { d: "M 30 210 L 90 210 L 90 150 L 150 150 L 150 90 L 210 90", stroke: color, strokeWidth: "4", fill: "none", strokeLinecap: "round", initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: {
                    duration: 2,
                    repeat: Infinity,
                    repeatType: "loop",
                    ease: "easeInOut",
                    repeatDelay: 0.5
                } }),
            [
                { x: 30, y: 210 },
                { x: 90, y: 150 },
                { x: 150, y: 90 },
                { x: 210, y: 90 }
            ].map((pos, i) => {
                // Replace middle node (index 1 for 4 nodes) with spark
                if (i === 1) {
                    return (React.createElement(motion.g, { key: i },
                        React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "15", stroke: color, strokeWidth: "1.5", fill: "none", strokeDasharray: "3,3", initial: { scale: 0, opacity: 0 }, animate: {
                                scale: [0, 1.8],
                                opacity: [0, 0.6, 0]
                            }, transition: {
                                delay: i * 0.4,
                                duration: 1.2,
                                repeat: Infinity,
                                repeatDelay: 2.3,
                                repeatType: "loop",
                                ease: "easeOut"
                            } }),
                        React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "15", stroke: color, strokeWidth: "1", fill: "none", strokeDasharray: "3,3", initial: { scale: 0, opacity: 0 }, animate: {
                                scale: [0, 2.2],
                                opacity: [0, 0.4, 0]
                            }, transition: {
                                delay: i * 0.4 + 0.2,
                                duration: 1.2,
                                repeat: Infinity,
                                repeatDelay: 2.3,
                                repeatType: "loop",
                                ease: "easeOut"
                            } }),
                        React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "12", stroke: "none", fill: colorGlow, initial: { scale: 0, opacity: 0 }, animate: {
                                scale: [0, 2.5],
                                opacity: [0, 0.3, 0]
                            }, transition: {
                                delay: i * 0.4,
                                duration: 1.4,
                                repeat: Infinity,
                                repeatDelay: 2.1,
                                repeatType: "loop",
                                ease: "easeOut"
                            } }),
                        React.createElement(motion.g, { initial: { scale: 0 }, animate: {
                                scale: [1, 1.15, 1],
                                rotate: [0, 15, 0]
                            }, transition: {
                                delay: i * 0.4,
                                duration: 2,
                                repeat: Infinity,
                                repeatDelay: 1.5,
                                repeatType: "loop"
                            } },
                            React.createElement("g", { transform: `translate(${pos.x - 18}, ${pos.y - 18}) scale(2.571)` },
                                React.createElement("path", { d: "M13.98 6.01998V7.97998H9.36L12.64 11.24L11.24 12.64L7.98 9.35998V14H6V9.35998L2.74 12.64L1.34 11.24L4.62 7.97998H1.49012e-08V6.01998H4.62L1.34 2.73998L2.74 1.33998L6 4.61998V-2.07424e-05H7.98V4.61998L11.24 1.33998L12.64 2.73998L9.36 6.01998H13.98Z", fill: colorLight })))));
                }
                return (React.createElement(motion.g, { key: i },
                    React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "15", stroke: color, strokeWidth: "1.5", fill: "none", strokeDasharray: "3,3", initial: { scale: 0, opacity: 0 }, animate: {
                            scale: [0, 1.8],
                            opacity: [0, 0.6, 0]
                        }, transition: {
                            delay: i * 0.4,
                            duration: 1.2,
                            repeat: Infinity,
                            repeatDelay: 2.3,
                            repeatType: "loop",
                            ease: "easeOut"
                        } }),
                    React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "15", stroke: color, strokeWidth: "1", fill: "none", strokeDasharray: "3,3", initial: { scale: 0, opacity: 0 }, animate: {
                            scale: [0, 2.2],
                            opacity: [0, 0.4, 0]
                        }, transition: {
                            delay: i * 0.4 + 0.2,
                            duration: 1.2,
                            repeat: Infinity,
                            repeatDelay: 2.3,
                            repeatType: "loop",
                            ease: "easeOut"
                        } }),
                    React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "12", stroke: "none", fill: colorGlow, initial: { scale: 0, opacity: 0 }, animate: {
                            scale: [0, 2.5],
                            opacity: [0, 0.3, 0]
                        }, transition: {
                            delay: i * 0.4,
                            duration: 1.4,
                            repeat: Infinity,
                            repeatDelay: 2.1,
                            repeatType: "loop",
                            ease: "easeOut"
                        } }),
                    React.createElement(motion.circle, { cx: pos.x, cy: pos.y, r: "8", fill: color, initial: { scale: 0 }, animate: { scale: 1 }, transition: {
                            delay: i * 0.4,
                            duration: 0.3,
                            repeat: Infinity,
                            repeatDelay: 2.5,
                            repeatType: "loop"
                        } })));
            }),
            React.createElement(motion.circle, { cx: "30", cy: "210", r: "8", fill: color, initial: { offsetDistance: "0%", scale: 1 }, animate: {
                    offsetDistance: "100%",
                    scale: [1, 1.3, 1]
                }, transition: {
                    duration: 2,
                    repeat: Infinity,
                    repeatType: "loop",
                    ease: "easeInOut",
                    repeatDelay: 0.5
                }, style: {
                    offsetPath: "path('M 30 210 L 90 210 L 90 150 L 150 150 L 150 90 L 210 90')"
                } }))));
}
